import { Stack } from '@mui/material'

import { useMutatePersonalSettings } from '@/services'
import { PersonCustomizationDialog } from '@/components/person-customization-dialog.tsx'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { useAppSelector } from '@/stores/hooks.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'

import { KEY_PAGE, defaultSettings, PartialOperation } from '../default-settings.tsx'
import { NewOperationRequestDialog } from '../new-operation-request-dialog.tsx'

export const OperationRequestsActions = () => {
  const settings = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE))

  const getSettings = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(defaultSettings)
    const settings: RowProps[] = settingsByRequest.map((e) => ({
      id: e,
      label: defaultSettings[e as keyof PartialOperation],
      isChecked: true,
    }))
    Object.keys(defaultSettings).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({ id: key, label: defaultSettings[key as keyof PartialOperation], isChecked: false })
      }
    })

    return settings
  }

  return (
    <Stack
      direction={{ sm: 'column', px526: 'row' }}
      gap={2}
      justifyContent={{ sm: 'flex-start', px526: 'flex-end' }}
      alignItems="flex-start"
    >
      <NewOperationRequestDialog />
      <PersonCustomizationDialog
        personalSettingsKey={KEY_PAGE}
        mutation={useMutatePersonalSettings()}
        itemsDesktop={getSettings('desktop', settings)}
        itemsMobile={getSettings('mobile', settings)}
      />
    </Stack>
  )
}
